import { getThumbUrl } from './imageUrl';

/**
 * Közös bélyegkép-hibacache. A listakártyák a `_thumb.webp` változatot kérik (getThumbUrl); a régebbi
 * képeknél ez 404 lehet (amíg a backend/scripts/generateProviderImageThumbnails.js le nem fut). Ha ezt minden
 * kártya külön tanulja meg, kártyánként egy felesleges kérés + késés jön, és addig üres a képhely
 * (görgetéskori „háttérsávok”). Itt munkamenetenként egyszer derül ki, utána egyből az eredeti töltődik.
 */
const STORAGE_KEY = 'wedigo.failedThumbs';
const MAX_ENTRIES = 500;

const failedThumbs = (() => {
  try {
    return new Set(JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '[]'));
  } catch {
    return new Set();
  }
})();

const persist = () => {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify([...failedThumbs].slice(-MAX_ENTRIES)));
  } catch {
    // privát mód / tele tároló: a memóriabeli cache így is működik
  }
};

// A kép bélyegképe, vagy az eredeti, ha a bélyegképről már kiderült, hogy nincs
export const getThumbOrOriginal = (url) => {
  const thumb = getThumbUrl(url);
  return thumb && failedThumbs.has(thumb) ? url : thumb;
};

export const isThumbFailed = (url) => failedThumbs.has(getThumbUrl(url));

// A bélyegkép betöltése sikertelen volt → ettől kezdve (a munkamenetben) az eredetit használjuk
export const markThumbFailed = (url) => {
  const thumb = getThumbUrl(url);
  if (!thumb || thumb === url || failedThumbs.has(thumb)) return;
  failedThumbs.add(thumb);
  persist();
};
